import React from "react";
import styled from "styled-components";
import { ConfigurationRenderProps } from "../StrikeZoneRender";

type ImgProps = {
  width: number;
};

const Img = styled.img<ImgProps>`
  width: ${(props) => props.width + "px"};
`;

const BattersBox: React.FC<ConfigurationRenderProps> = ({ config }) => {
  const {
    palette,
    scaling,
    display: { isPitchersView },
  } = config;
  return <Img src={isPitchersView ? palette.pitchersBoxSrc : palette.battersBoxSrc} width={scaling.width} />;
};

export default BattersBox;
